import React from 'react';
import { Check } from 'lucide-react';

const LanguageOption = ({ language, isSelected, onClick }) => {
  // Enhanced flag badge with country code - works on all platforms
  const renderFlag = (isoCode) => {
    // Define color schemes for different countries
    const colorSchemes = {
      GB: 'from-blue-500 to-red-500',
      UA: 'from-blue-400 to-yellow-400',
      RU: 'from-blue-600 to-red-600',
      TH: 'from-red-500 to-blue-600',
      DE: 'from-yellow-400 to-red-500',
      FR: 'from-blue-600 to-red-500',
      CN: 'from-red-600 to-yellow-400',
      ES: 'from-yellow-400 to-red-600',
      IL: 'from-blue-500 to-white',
      NL: 'from-red-500 to-blue-600',
      IT: 'from-green-500 to-red-500'
    };

    const gradient = colorSchemes?.[isoCode] || 'from-gray-400 to-gray-600';

    return (
      <span 
        className={`inline-flex items-center justify-center w-8 h-8 bg-gradient-to-br ${gradient} text-white text-[10px] font-bold rounded-full shadow-lg border-2 border-white transform hover:scale-110 transition-transform duration-200`}
      >
        {isoCode}
      </span>
    );
  };

  return (
    <button
      onClick={() => onClick?.(language?.code)}
      className={`flex items-center gap-1.5 p-1.5 rounded-lg transition-all duration-300 w-full transform hover:scale-[1.02] hover:-translate-y-0.5 ${
        isSelected
          ? 'bg-gradient-to-r from-blue-500 via-blue-600 to-purple-600 text-white shadow-xl shadow-blue-500/50 border-2 border-blue-300'
          : 'bg-gradient-to-br from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-700 shadow-lg hover:shadow-xl border-2 border-gray-200 hover:border-gray-300'
      }`}
    >
      {/* Flag */}
      <div className="flex-shrink-0">
        {renderFlag(language?.flag)}
      </div>

      {/* Language Info */}
      <div className="flex-1 text-left min-w-0">
        <div className="text-sm font-semibold truncate drop-shadow-sm">{language?.name}</div>
        <div className="text-[10px] opacity-90 truncate">{language?.nativeName}</div>
      </div>

      {/* Selection Indicator */}
      {isSelected && (
        <div className="flex-shrink-0">
          <div className="w-5 h-5 bg-white rounded-full flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform">
            <Check className="w-3 h-3 text-blue-600" />
          </div>
        </div>
      )}

      {/* Radio Button (when not selected) */}
      {!isSelected && (
        <div className="flex-shrink-0">
          <div className="w-5 h-5 border-2 border-gray-400 rounded-full shadow-md bg-white" />
        </div>
      )}
    </button>
  );
};

export default LanguageOption;